import { extendTheme } from '@mui/joy/styles';

export const theme = extendTheme({
  typography: {},
  fontFamily: {
    body: 'Figtree, sans-serif',
    display: 'Figtree, sans-serif',
  },
  fontSize: {
    md: '14px',
  },
  fontWeight: {
    xs: 300,
    sm: 400,
    md: 500,
    lg: 600,
    xl: 700,
  },
  components: {
    JoyListItemDecorator: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.vars.palette.text.icon,
        }),
      },
    },
    JoyListItemButton: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          ...(ownerState.selected && {
            '& .MuiListItemContent-root': {
              color: theme.vars.palette.text.primary,
              fontWeight: theme.fontWeight.xl,
            },
            '& .MuiListItemDecorator-root': {
              color: theme.vars.palette.text.primary,
            },
          }),
        }),
      },
    },
  },
});
